import { gsap } from "@gsap";

/**
 * Layout: Hero - Home
 * Slug: hero_home
 */

const initHeroAnimations = () => {
    document.querySelectorAll(".flex-layout.hero_archive-layout").forEach((layout) => {
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeroAnimations, { once: true });
} else {
    initHeroAnimations();
}
